export default "__VITE_ASSET__CXP3XC0h__"